import colors from '../tokens/colors';

export const toggleSwitchGetolo = {
  switchColor: colors.PROFESSIONAL_BLUE,
};

export const toggleSwitchDaDirekt = {
  switchColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
};

export const toggleSwitchDaKaufland = {
  switchColor: colors.DA_KAUFLAND_BLACK,
};

export const toggleSwitchFressnapf = {
  switchColor: colors.FRESSNAPF_PRIMARY_HOVER,
};
